import {
  useGetSingleSalesChannelForAuthorityQuery,
  useGetSingleSalesChannelInfoQuery
} from 'Services/SalesManagement/Features/TicketSale/salesChannelApi'
import SnackbarUtils from 'Util/Snackbar'
import { useEffect } from 'react'
import { t } from 'ttag'

export function useSalesChannelData(authorityCode: string | undefined) {
  const { data: singleSalesChannel, isError: isGetSingleSalesChannelError } =
    useGetSingleSalesChannelForAuthorityQuery(
      { authorityCode: authorityCode as string },
      { skip: !authorityCode }
    )

  useEffect(() => {
    if (isGetSingleSalesChannelError) {
      SnackbarUtils.error(t`Failed to fetch the sales channel for the authority.`)
    }
  }, [isGetSingleSalesChannelError])

  const { data: salesChannelInfo, isFetching: isSalesChannelInfoFetching } =
    useGetSingleSalesChannelInfoQuery(
      { salesChannelId: singleSalesChannel?.external_id as string },
      { skip: !singleSalesChannel?.external_id }
    )

  return { singleSalesChannel, salesChannelInfo, isSalesChannelInfoFetching }
}
